import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=0e94b031&lang=pug&"
import script from "./ProjectForm.vue?vue&type=script&lang=js&"
export * from "./ProjectForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports